/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { BarLoader } from "../../../../shared/widgets";
import { templateStrings } from "../../../../Constant";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { mobileTicketsDetailsAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { getListUtil } from "../../../../shared/utils";

class MobileTicketDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.mobileTicketDetailGetList();
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps && prevProps.cityFilter !== this.props.cityFilter)
            || (prevProps && prevProps.operatorFilter !== this.props.operatorFilter)
            || (prevProps && prevProps.dateFilter !== this.props.dateFilter)
    ) {
      this.mobileTicketDetailGetList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.mobileTicketDetailGetList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.mobileTicketDetailGetList();
      }
    });
  };

  mobileTicketDetailGetList = () => {
    if (
      get(this, "props.location.state.fromDate", null)
        && get(this, "props.location.state.toDate", null)
    ) {
      getListUtil({
        dispatchFn: this.props.fetchMobileTicketsDetails, props: this.props, state: this.state, extraParam: "header",
      });
    } else {
      const { history } = this.props;
      history.push("/report/mobile-ticket");
    }
  };

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.reportMobileTicketsDetails;
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header
            heading="Mobile Ticket Details"
            showBackArrow
            hideS
          />
          <BarLoader scope="header" />
          <TableWrapper
            content={!headerLoader && content}
            pageNo={pageNo}
            selected={selected}
            uniqueKey="uniqKey"
            rowsPerPage={rowsPerPage}
            count={totalItems}
            handleChange={this.handleChange}
            templateString={templateString}
            selectionAllowed={false}
            onSortToggle={this.onSortToggle}
            sortBy={sortBy}
          />
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
        (state && state.Report && state.Report.mobileTicketsDetails && state.Report.mobileTicketsDetails.data) || [],
    totalItems:
        (state && state.Report && state.Report.mobileTicketsDetails && state.Report.mobileTicketsDetails.totalItems) || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchMobileTicketsDetails: (value, loaderScope) => {
    dispatch(mobileTicketsDetailsAction(value, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileTicketDetails);
